
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/money-fortune",
      function () {
        return require("private-next-pages/money-fortune/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/money-fortune"])
      });
    }
  